const canvas = document.getElementById("game");
const ctx = canvas.getContext("2d");
const leftScoreEl = document.getElementById("left-score");
const rightScoreEl = document.getElementById("right-score");
const timerEl = document.getElementById("timer");
const teamEl = document.getElementById("team-indicator");
const countEl = document.getElementById("player-count");

const R = 25;
const styles = getComputedStyle(document.documentElement);
const TEAM_LEFT_COLOR = styles.getPropertyValue("--color-team-left").trim();
const TEAM_RIGHT_COLOR = styles.getPropertyValue("--color-team-right").trim();

let pucks = [];
let team = null;
let winner = null;
let dragging = false;
let start = { x: 0, y: 0 };

const ws = new WebSocket(
  `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}/ws`,
);

ws.onmessage = ({ data }) => {
  const d = JSON.parse(data);
  if (d.type === "init") {
    team = d.team;
    teamEl.textContent = `Team ${team === "left" ? "Blue" : "Red"}`;
    teamEl.className =
      team === "left"
        ? "text-team-left font-medium"
        : "text-team-right font-medium";
  }
  if (d.type === "queued") {
    team = null;
    teamEl.textContent = `Queue #${d.queuePosition}`;
    teamEl.className = "text-gray-500";
  }
  if (
    d.canvasWidth &&
    (d.canvasWidth !== canvas.width || d.canvasHeight !== canvas.height)
  ) {
    canvas.width = d.canvasWidth;
    canvas.height = d.canvasHeight;
  }
  if (d.pucks) pucks = d.pucks;
  if (d.leftScore !== undefined) {
    leftScoreEl.textContent = d.leftScore;
    rightScoreEl.textContent = d.rightScore;
  }
  if (d.leftPlayers !== undefined) {
    countEl.textContent = `${d.leftPlayers + d.rightPlayers} players`;
  }
  if (d.timeLeft !== undefined) timerEl.textContent = d.timeLeft;
  if (d.winner !== undefined) winner = d.winner;
};

ws.onclose = () => {
  teamEl.textContent = "Disconnected";
  teamEl.className = "text-gray-400";
};

function pos(e) {
  const r = canvas.getBoundingClientRect();
  const cx = e.touches ? e.touches[0].clientX : e.clientX;
  const cy = e.touches ? e.touches[0].clientY : e.clientY;
  return {
    x: ((cx - r.left) * canvas.width) / r.width,
    y: ((cy - r.top) * canvas.height) / r.height,
  };
}

function push(end) {
  if (ws.readyState === 1 && !winner) {
    ws.send(
      JSON.stringify({
        type: "push",
        ...start,
        dx: end.x - start.x,
        dy: end.y - start.y,
      }),
    );
  }
}

canvas.onmousedown = (e) => {
  dragging = true;
  start = pos(e);
};
canvas.onmouseup = (e) => {
  if (dragging) {
    dragging = false;
    push(pos(e));
  }
};

canvas.ontouchstart = (e) => {
  e.preventDefault();
  dragging = true;
  start = pos(e);
};
canvas.ontouchend = (e) => {
  if (!dragging) return;
  dragging = false;
  const t = e.changedTouches?.[0];
  if (t) {
    const r = canvas.getBoundingClientRect();
    push({
      x: ((t.clientX - r.left) * canvas.width) / r.width,
      y: ((t.clientY - r.top) * canvas.height) / r.height,
    });
  } else {
    push(start);
  }
};

function draw() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  const mid = canvas.width / 2;

  if (team) {
    ctx.globalAlpha = 0.03;
    ctx.fillStyle = team === "left" ? TEAM_LEFT_COLOR : TEAM_RIGHT_COLOR;
    ctx.fillRect(team === "left" ? 0 : mid, 0, mid, canvas.height);
    ctx.globalAlpha = 1;
  }

  ctx.strokeStyle = "#e5e7eb";
  ctx.lineWidth = 2;
  ctx.setLineDash([10, 10]);
  ctx.beginPath();
  ctx.moveTo(mid, 0);
  ctx.lineTo(mid, canvas.height);
  ctx.stroke();
  ctx.setLineDash([]);

  for (const p of pucks) {
    ctx.fillStyle = "rgba(0,0,0,0.1)";
    ctx.beginPath();
    ctx.arc(p.x + 2, p.y + 2, R, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = p.color;
    ctx.beginPath();
    ctx.arc(p.x, p.y, R, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = "rgba(255,255,255,0.3)";
    ctx.beginPath();
    ctx.arc(p.x - 5, p.y - 5, R * 0.3, 0, Math.PI * 2);
    ctx.fill();
  }

  if (dragging && !winner) {
    ctx.fillStyle = "rgba(0,0,0,0.2)";
    ctx.beginPath();
    ctx.arc(start.x, start.y, 8, 0, Math.PI * 2);
    ctx.fill();
  }

  if (winner) {
    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#fff";
    ctx.font = "bold 48px Arial";
    ctx.textAlign = "center";
    ctx.fillText(
      winner === "tie" ? "Tie!" : `${winner === "left" ? "Blue" : "Red"} Wins!`,
      mid,
      canvas.height / 2,
    );
    ctx.font = "24px Arial";
    ctx.fillText("Next round starting...", mid, canvas.height / 2 + 40);
  }

  requestAnimationFrame(draw);
}

draw();
